import React from 'react'
import Icon from '../icon'
import { TagWapper, ButtonRemove } from './styles'

type Props = {
  'data-qa'?: string
  label: string
  onClick?: () => void
  icon?: string
  size?: 'small' | 'medium' | 'large'
  state?: 'static' | 'removable'
  theme?: 'enabled' | 'active' | 'disabled' | 'negative' | 'positive'
  onRemove?: Function
}

const Tag: React.FC<Props> = (props: Props): JSX.Element => {
  const isDisabled: boolean = props.theme === 'disabled'

  return (
    <TagWapper
      className={`theme-${props.theme} size-${props.size}`}
      data-qa={props['data-qa']}
      onClick={props?.onClick}
    >
      {props.icon && <Icon name={props.icon} size={16} />}

      <span data-qa={props['data-qa'] && `${props['data-qa']}-label`}>
        {props.label}
      </span>

      {props.state === 'removable' && (
        <ButtonRemove
          data-qa={props['data-qa'] && `${props['data-qa']}-remove-button`}
          onClick={() => !isDisabled && props.onRemove()}
          disabled={isDisabled}
        >
          <Icon name="close" size={14} />
        </ButtonRemove>
      )}
    </TagWapper>
  )
}

Tag.defaultProps = {
  theme: 'enabled',
  size: 'medium',
  state: 'static',
}

export default Tag
